import { createContext } from 'react';

import {
  Country,
  defaultSearchCountry,
  defaultSearchLanguage,
  LowerCaseSearchLanguage,
  SearchLanguage,
} from '@models/CountriesAndLanguages';

import { useLocalStorage } from './useLocalStorage';

export type SearchContextValues = {
  country: Country;
  /**
   * Lowercase search language
   */
  lcSearchLanguage: LowerCaseSearchLanguage;
  searchLanguage: SearchLanguage;
  setCountry: (country: Country) => void;
  setSearchLanguage: (searchLanguage: SearchLanguage) => void;
};

export const SearchContext = createContext<SearchContextValues>({
  country: 'no',
  lcSearchLanguage: 'no',
  searchLanguage: 'No',
  setCountry: () => void 0,
  setSearchLanguage: () => void 0,
});

export const useSearchContext = () => {
  const [country, setCountry] = useLocalStorage<Country>('country', defaultSearchCountry);

  const [searchLanguage, setSearchLanguage] = useLocalStorage<SearchLanguage>(
    'searchLanguage',
    defaultSearchLanguage
  );

  const lcSearchLanguage = searchLanguage.toLowerCase() as LowerCaseSearchLanguage;

  return {
    country,
    lcSearchLanguage,
    searchLanguage,
    setCountry,
    setSearchLanguage,
  };
};

export default useSearchContext;
